import React from "react";

import PackageFooter from "./PackageFooter.jsx";
import PackageHeader from "./PackageHeader.jsx";
import PackageSection from "./PackageSection.jsx";

const NOOP = () => {};

const handleHover = (highlightOffer, id) => () => highlightOffer(id || null);

const article = props => (
  <article data-landscape={props.isMapView ? "" : null} className={props.isBookOnline ? "online" : null}>
    <PackageHeader {...props} />

    <PackageSection {...props} />

    <PackageFooter {...props} />
    {props.isBookOnline && (<span className="online-tab"><i className="fa fa-li fa-arrow-pointer"></i>BOOKABLE ONLINE</span>)}
  </article>
);

const Package = props => {
  const { highlightOffer, isMapView, offerId } = props;
  const hover = isMapView ? handleHover : NOOP;

  return (
    <section
      className={props.isHighlighted ? "highlight" : null}
      id={offerId}
      data-component="package-block"
      onMouseEnter={hover(highlightOffer, offerId)}
      onMouseLeave={hover(highlightOffer)}
    >
      {article(props)}
    </section>
  );
};

export default Package;



// WEBPACK FOOTER //
// ./components/search/package/Package.jsx